import React, { useState, useEffect } from "react";
import { Project, PaginationMeta, ProjectDeveloper, Country } from "@/types";
import ProjectList from "@/components/ProjectList";
import { useLanguage } from "@/contexts/LanguageContext";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ListIcon, MapPin } from "lucide-react";
import ProjectsOverviewClusteredMap from "./ProjectsOverviewClusteredMap";
import ProjectFilter from "./ProjectFilter";

interface ProjectTabViewProps {
  projectDevelopers: ProjectDeveloper[];
  projectDeveloperId: string;
  handleDeveloperChange: (developerId: string) => void;
  isLoadingDevelopers: boolean;
  countries: Country[];
  countryCode: string;
  handleCountryChange: (countryCode: string) => void;
  isLoadingCountries: boolean;
  projects: Project[];
  isLoading: boolean;
  meta?: PaginationMeta;
  onPageChange: (page: number) => void;
  currentPage: number;
}

const ProjectTabView: React.FC<ProjectTabViewProps> = ({
  projectDevelopers,
  projectDeveloperId,
  handleDeveloperChange,
  isLoadingDevelopers,
  countries,
  countryCode,
  handleCountryChange,
  isLoadingCountries,
  projects,
  isLoading,
  meta,
  onPageChange,
  currentPage,
}) => {
  const { t } = useLanguage();

  // State to track the selected tab
  const [selectedTab, setSelectedTab] = useState<string>(
    () => localStorage.getItem("selectedTab") || "list"
  );

  // Update localStorage whenever the selected tab changes
  useEffect(() => {
    localStorage.setItem("selectedTab", selectedTab);
  }, [selectedTab]);

  return (
    <Tabs value={selectedTab} onValueChange={setSelectedTab} className="w-full">
      <TabsList className="w-full mb-6 grid grid-cols-2">
        <TabsTrigger value="list" className="flex items-center gap-2">
          <ListIcon className="h-4 w-4" />
          <span>{t("projects.listView")}</span>
        </TabsTrigger>
        <TabsTrigger value="map" className="flex items-center gap-2">
          <MapPin className="h-4 w-4" />
          <span>{t("projects.mapView")}</span>
        </TabsTrigger>
      </TabsList>

      <TabsContent value="list" className="mt-0">
        <div className="bg-white rounded-xl shadow-sm">
          {/* <div classNam="p-6"> */}
          <ProjectFilter
            projectDevelopers={projectDevelopers}
            selectedDeveloperId={projectDeveloperId}
            onDeveloperChange={handleDeveloperChange}
            isLoading={isLoadingDevelopers}
            countries={countries}
            selectedCountryCode={countryCode}
            onCountryChange={handleCountryChange}
            isLoadingCountries={isLoadingCountries}
          />

          <div className="mt-6 border-t pt-6">
            <ProjectList
              projects={projects}
              isLoading={isLoading}
              meta={meta}
              onPageChange={onPageChange}
              currentPage={currentPage}
            />
          </div>
        </div>
      </TabsContent>

      <TabsContent value="map" className="mt-0">
        <ProjectsOverviewClusteredMap />
      </TabsContent>
    </Tabs>
  );
};

export default ProjectTabView;
